import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'tiny-invariant';
import GlobalizeContext from '../GlobalizeProvider/GlobalizeContext';
/**
 * @component
 */

function ChangePreferredLocale(_ref) {
  var children = _ref.children,
      render = _ref.render,
      rest = _objectWithoutProperties(_ref, ["children", "render"]);

  invariant(children || render, 'ChangePreferredLocale at least one prop children or render have to be defined');
  var renderer = children || render;
  return /*#__PURE__*/React.createElement(GlobalizeContext.Consumer, null, function (_ref2) {
    var changePreferredLocale = _ref2.changePreferredLocale;
    return renderer(_extends({}, rest, {
      changePreferredLocale: changePreferredLocale
    }));
  });
}

process.env.NODE_ENV !== "production" ? ChangePreferredLocale.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func
} : void 0;
ChangePreferredLocale.defaultProps = {
  children: undefined,
  render: undefined
};
export default ChangePreferredLocale;